import { usePortalStore } from '@/stores/portal.store'

export const useTranslations = () => {
  const portalStore = usePortalStore()

  const withTranslatedFields = (fields, translations = null) => ({
    ...(translations ?? { [window.config.DEFAULT_LANGUAGE]: fields }),
    [portalStore.selectedLanguage]: { ...translations?.[portalStore.selectedLanguage], ...fields },
  })

  return { withTranslatedFields }
}
